import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './DeleteRuleModal.module.scss';

export const DeleteRuleModal = ({ isOpen, onClose, onConfirm, isDisabled, hasError }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="DeleteRuleModal__modal" isOpen={isOpen} withFooter customClass={CN.deleteRuleModal} onClose={onClose}>
      <SalonModal.Header>
        <div className={CN.deleteRuleModalHeader}>
          <span className={CN.title}>{t('composite.deleteRuleModal.title')}</span>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.deleteRuleModalText}>{t('composite.deleteRuleModal.message')}</div>
        {hasError && <div className={CN.error}>{t('composite.deleteRuleModal.errorMessage')}</div>}
      </SalonModal.Body>
      <SalonModal.Footer className={CN.deleteRuleModalFooter}>
        <Button variant="slim" onClick={onClose}>
          {t('composite.deleteRuleModal.cancelButton')}
        </Button>
        <Button variant="alert" onClick={onConfirm} isDisabled={isDisabled}>
          {t('composite.deleteRuleModal.confirmButton')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};
